import React, { useEffect, useState } from 'react';
import profile_image from '../../assests/images/profile_image.png';
import '../../assests/css/MyProfile.css';
import Header from '../Headers/Header';
import Footer from '../Footers/Footer';
import { useNavigate } from 'react-router-dom';

const EditProfile = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [info, setInfo] = useState({
        fname: "",
        lname: "",
        phone: "",
        gender: "",
        dob: "",
        country: "",
    });

    const navigate = useNavigate();

    const UploadImage = (event) => {
        if ((event.target.files[0].size / 1000000) <= 5) {
            setSelectedImage(event.target.files[0]);
            console.log('sucess', (event.target.files[0].size / 1000000))
        } else {
            window.alert('file size is greater than 5 mb');
            // console.log('not success', event.target.files[0].size);
        }
    }

    const InputVal = (e) => {
        let { name, value } = e.target;
        setInfo({ ...info, [name]: value });
    }


    // console.log(info);

    return (
        <div className='myProfile'>
            <div className='edit_profile'>
                <section className='bg-privacy-policy-top mb-5'>
                    <Header />
                    <div className='container px-5'>
                        <div className='row px-3'>
                            <div className='col-lg-12 my-4 text-center'>
                                <p className='text-white f-72 my-5 f-pop-med'>My Profile</p>
                            </div>
                        </div>
                    </div>
                </section>
                <div className='container  my-5'>
                    <div className='row my-5'>
                        <div className='col-lg-12 my-5'>
                            <div className='card crd-edit-profile rounded-0'>
                                <div className='card-body p-5'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <p className='f-pop-med f-35'>Basic Information</p>
                                        </div>
                                        <div className='col-sm-8 mt-5 mb-3'>
                                            <div className='d-flex'>
                                                <img className='images_profile_edit' src={(!selectedImage) ? profile_image : URL.createObjectURL(selectedImage)} alt="preview_image" />
                                                <div className='ms-4'>
                                                    <p className='f-pop-med f-13 clr-a4 '>Jpeg or png maximum size (5mb)</p>
                                                    <button className='btn btn-danger bt-upload-basicinfo f-14 f-pop-med mt-3'>
                                                        <input name="myImage"
                                                            accept="image/png,image/jpeg"
                                                            onChange={UploadImage} className='upload_photo_editprofile' id="file-upload" type="file" />
                                                        Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-4 text-end mt-5 mb-3'>
                                            <p className='clr-a4 f-pop-med f-13'>Processing</p>
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <input name="fname"
                                                value={info.fname || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='First Name' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control'
                                            />
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <input
                                                name="lname"
                                                value={info.lname || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='Last Name' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <input
                                                name="phone"
                                                value={info.phone || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='Phone ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <select className='form-control p-3 f-14 f-pop-med'>
                                                <option >
                                                    Gender
                                                </option>
                                                <option >
                                                    Male
                                                </option>
                                                <option >
                                                    Female
                                                </option>
                                            </select>
                                            {/* <input
                                                name="phone"
                                                value={info.phone || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='Gender ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' /> */}
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <input
                                                name="dob"
                                                value={info.dob || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='Date of Birth ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-6 mt-4'>
                                            <input
                                                name="country"
                                                value={info.country || ""}
                                                onChange={InputVal}
                                                type="text" placeholder='Country ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        {/* <div className='col-lg-4 mt-4'>
                                            <input type="Password" placeholder='Current Password ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-4 mt-4'>
                                            <input type="Password" placeholder='New Password ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div>
                                        <div className='col-lg-4 mt-4'>
                                            <input type="Password" placeholder='Confirm Password ' className='p-3 inpt-fld-editprof f-14 f-pop-med form-control' />
                                        </div> */}
                                        <div className='col-lg-7 align-self-center mt-4'>
                                            <input type="checkbox" className='mt-3' /><span className='ms-2 f-13 clr-a4 '>Terms and conditions Easily generate and manage a Terms and Conditions.</span>
                                        </div>
                                        <div className='col-lg-5 text-end mt-4'>
                                            <button onClick={() => { navigate('/myprofile') }} className='btn btn-danger bt-upload-basicinfo f-14 f-pop-med mt-3 '>Submit</button>
                                            <button onClick={() => { navigate('/myprofile') }} className='btn btn-secondary  clr-white-btn-edt  f-14 f-pop-med mt-3 ms-3 border-0'>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default EditProfile;